import Vue from 'vue'
import Router from 'vue-router'
import publicHome from '@/components/home'
import home from '@/views/home'
import towait from '@/views/home/towait'
import test from '@/views/test'
import details from '@/views/home/details'
import login from '@/views/login'
//公共页面
import publicHtml from '@/components/public'

import shopJs from './shop.js'
import saleJs from './sale.js'
import commodityJs from './commodity.js'
import financialJs from './financial.js'
import learningJs from './learning.js'
import settingJs from './setting.js'
import storesJs from './stores.js'
Vue.use(Router)

/**
 * 从 localStorage 安全读取 token
 * @returns {string}
 */
function getRouteToken() {
	var raw = window.localStorage.getItem('token')
	if (!raw) return ''
	try {
		var parsed = JSON.parse(raw)
		if (parsed && parsed.data && parsed.data.obj && parsed.data.obj.token) {
			return parsed.data.obj.token
		}
		return ''
	} catch (e) {
		return ''
	}
}

const router = new Router({
	scrollBehavior (to, from, savedPosition) {
	 // return 期望滚动到哪个的位置
	 return { x: 0, y: 0 }
	},
  routes: [
		{
      path: '/',
      name: 'publicHome',
      component: publicHome,
			redirect:'home',
			children:[
				{
				  path: '/',
				  name: 'home',
				  component: home
				},
				{
				  path: '/details',
				  name: 'details',
					meta:[{name:'清单详情'}],
				  component: details
				},
				{
				  path: '/towait',
				  name: 'towait',
				  component: towait
				},
			]
    },
		{
      path: '/login',
      name: 'login',
      component: login
    },
		{
			path: '/sale/login',
			name: 'saleLogin',
			component: resolve => require(['@/views/sale/login'], resolve)
		},
		{
			path: '/sale/intellectualProperty',
			name: 'saleIntellectualProperty',
			component: resolve => require(['@/views/sale/intellectualProperty'], resolve)
		},
		{
			path: '/sale/terms',
			name: 'saleTerms',
			component: resolve => require(['@/views/sale/terms'], resolve)
		},
		{
			path: '/sale/privacy',
			name: 'salePrivacy',
			component: resolve => require(['@/views/sale/privacy'], resolve)
		},
		{
			path: '/sale/contact',
			name: 'saleContact',
			component: resolve => require(['@/views/sale/contact'], resolve)
		},
		{
			path: '/sale/returnPolicy',
			name: 'saleReturnPolicy',
			component: resolve => require(['@/views/sale/returnPolicy'], resolve)
		},
		{
			path: '/sale/purchaseSuccess',
			name: 'salePurchaseSuccess',
			component: resolve => require(['@/views/sale/purchaseSuccess'], resolve)
		},
		{
      path: '/payment',
      name: 'payment',
      component: resolve => require(['@/views/payment/index'], resolve)
    },
		{
      path: '/shop/orderNew',
      name: 'orderNew',
      component: resolve => require(['@/views/shop/orderNew'], resolve)
    },
		{
      path: '/shop/orderNew/orderDetailsNew',
      name: 'orderDetailsNew',
      component: resolve => require(['@/views/shop/orderDetailsNew'], resolve)
    },	
		{
      path: '/shop/orderNew/orderDetails1New',
      name: 'orderDetails1New',
      component: resolve => require(['@/views/shop/Orderdetails1New'], resolve)
    },
		{
      path: '/shop/legalEntityOrderQuery',
      name: 'legalEntityOrderQuery',
      component: resolve => require(['@/views/shop/legalEntityOrderQuery'], resolve)
    },
		{
			path: '/shop/corporateOrderDetails',
			name: 'corporateOrderDetails',
			component: resolve => require(['@/views/shop/corporateOrderDetails'], resolve)
		},
			
		{
      path: '/publicHtml',
      name: 'publicHtml',
      component: publicHtml,
			children:[
				...shopJs,
				...saleJs,
				...commodityJs,
				...financialJs,
				...learningJs,
				...settingJs,
				...storesJs
			]
    },
		{
			path: '/test',
			name: 'test',
			component: test
		},		
		{
      path: "*",
      redirect: "/"
    }
  ]
})

router.beforeEach(function (to, from, next) {
	var isSalePublic =
		to.path === '/sale/login' ||
		to.path === '/sale/intellectualProperty' ||
		to.path === '/sale/terms' ||
		to.path === '/sale/privacy' ||
		to.path === '/sale/contact' ||
		to.path === '/sale/returnPolicy' ||
		to.path === '/sale/purchaseSuccess'
	var isSalePage = to.path.indexOf('/sale') === 0 && !isSalePublic
	if (isSalePage && !getRouteToken()) {
		next({ path: '/sale/login', replace: true })
		return
	}
	next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js